// extracted by mini-css-extract-plugin
module.exports = {"CANCOMProductContactsDialog":"CANCOMProducts_CANCOMProductContactsDialog__YmP5a"};